<template>
    <Card>
        <div class="card-body">
            <router-link class="btn btn-link" :to="{ name: 'TransferCreatePage' }">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="`/projects/${$route.params.projectUuid}/wms/transfers`"
            :columns="columns"
            v-model:orders="orders"
        >
            <template #td-id="{row}">
                <router-link :to="{ name: 'TransferEditPage', params: { transferUuid: row.uuid } }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-warehouse_from_name="{row}">
                {{ row.warehouse_from.name }}
            </template>
            <template #td-warehouse_to_name="{row}">
                {{ row.warehouse_to.name }}
            </template>
            <template #td-completed_at="{row}">
                <AppNullableCell>
                    <template #default v-if="row.completed_at">
                        {{ DateFormatter.formatDateTime(row.completed_at) }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import AppNullableCell from '../../../components/tables/AppNullableCell.vue';

import DateFormatter from '../../../../services/DateFormatter';

export default {
    name: 'TransferIndexPage',
    components: {
        Card, FetchTable, AppNullableCell
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            columns: [
                { key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true },
                { key: 'warehouse_from_name', name: this.$t('labels.warehouse_from'), width: '150px', type: 'string', order: false },
                { key: 'warehouse_to_name', name: this.$t('labels.warehouse_to'), width: '150px', type: 'string', order: false },
                { key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true },
                { key: 'completed_at', name: this.$t('table.titles.completed_at'), width: '200px', type: 'string', order: true },
            ],
            orders: []
        }
    },
    mounted() {
        this.tableHandle.fetchRows();
    }
}
</script>
